import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MatInputModule } from '@angular/material/input';
import { NotificationData } from '../../../../services/notification.service';
import { buildWayPurchaseSingleWashDisplayVm } from '../../utils/way-purchase-single-wash-display.util';
import { WayPurchaseSingleWashDisplayVm } from '../../models/way-purchase.models';
import { WAY_PURCHASE_PLATE_PLACEHOLDER } from '../../utils/way-purchase-plate.util';
import {
  resolveWayPurchaseDetailView,
  resolveWayPurchaseUnredeemableReason,
  shouldShowWayPurchaseSingleWashLayout,
} from '../../utils/way-purchase-layout.util';

@Component({
  selector: 'app-way-purchase-single-wash-layout',
  standalone: true,
  imports: [CommonModule, FormsModule, MatInputModule],
  templateUrl: './way-purchase-single-wash-layout.component.html',
  styleUrls: ['./way-purchase-single-wash-layout.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class WayPurchaseSingleWashLayoutComponent implements OnChanges {
  @Input() notification: NotificationData | null = null;
  @Input() needsPlateEntry = false;
  @Input() plateInput = '';
  @Input() plateInputError = '';
  @Input() plateInputDisabled = false;
  @Output() plateInputChange = new EventEmitter<string>();

  readonly platePlaceholder = WAY_PURCHASE_PLATE_PLACEHOLDER;
  isVisible = false;
  isUnavailable = false;
  unavailableReason = '';
  displayVm: WayPurchaseSingleWashDisplayVm | null = null;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['notification']) {
      const detail = resolveWayPurchaseDetailView(this.notification);
      this.isVisible = shouldShowWayPurchaseSingleWashLayout(this.notification);
      this.displayVm = detail ? buildWayPurchaseSingleWashDisplayVm(detail.data) : null;
      this.isUnavailable = detail?.isUnavailable === true;
      this.unavailableReason = this.isUnavailable
        ? resolveWayPurchaseUnredeemableReason(detail?.data, this.notification?.message)
        : '';
    }
  }

  onPlateInput(value: string): void {
    this.plateInputChange.emit(value);
  }
}
